import { Text, View } from "@react-pdf/renderer";

import { ConsultationExportSummaryConcerns } from "~/providers/components/pdf/ConsultationExport/ConsultationExportSummaryConcerns";
import { ConsultationExportSummaryDomains } from "~/providers/components/pdf/ConsultationExport/ConsultationExportSummaryDomains";
import { ConsultationExportSummaryScores } from "~/providers/components/pdf/ConsultationExport/ConsultationExportSummaryScores";
import { ConsultationExport } from "~/providers/utils/types/consultation";
import { styles } from "../styles";
import { ConsultationExportSummaryFillm } from "./ConsultationExportSummaryFillm";
import { ConsultationExportSummaryThemes } from "./ConsultationExportSummaryThemes";

export const ConsultationExportSummary = ({
  data: { summary },
}: {
  data: ConsultationExport;
}) => {
  if (!summary) return null;

  return (
    <>
      <View style={[styles.section, styles.tight]} break>
        <Text style={[styles.h1, styles.tight]}>
          Appendix: PsychNow-generated findings
        </Text>
      </View>

      <View style={[styles.section]}>
        <Text style={[styles.h2]}>Case summary</Text>

        <Text>{summary.caseSummary}</Text>
      </View>

      <View style={[styles.section, { borderBottom: 0 }]}>
        <Text style={[styles.h2]}>Functional domains</Text>

        <ConsultationExportSummaryDomains
          domains={summary.functionalDomains ?? []}
        />
      </View>

      {summary.fillm && (
        <View style={[styles.section, { borderBottom: 0 }]} break>
          <Text style={[styles.h2]}>Fillm</Text>

          <ConsultationExportSummaryFillm fillm={summary.fillm} />
        </View>
      )}

      {summary.responseThemes?.some((rt) => rt.triggered) && (
        <View
          style={[styles.section, { fontWeight: 500, borderBottom: 0 }]}
          break
        >
          <Text style={[styles.h2]}>Response themes</Text>

          <ConsultationExportSummaryThemes
            responseThemes={summary.responseThemes}
          />
        </View>
      )}

      <View
        style={[styles.section, { flexDirection: "column", rowGap: 8 }]}
        break
      >
        <Text style={[styles.h2, { marginBottom: 0 }]}>
          Treatment recommendations
        </Text>

        <Text style={[styles.h3, { marginBottom: 0 }]}>
          Cognitive behavioral therapy (CBT)
        </Text>

        <Text wrap>
          {summary.treatmentRecommendations?.cognitive_behavioral_therapy}
        </Text>

        <Text style={[styles.h3, { marginBottom: 0 }]}>
          Insight-oriented therapy
        </Text>

        <Text>
          {summary.treatmentRecommendations?.insight_oriented_therapy}
        </Text>
      </View>

      {summary.potentialAreasOfConcern?.length && (
        <View style={[styles.section, { fontWeight: 500 }]}>
          <Text style={[styles.h2]}>Potential areas of concern</Text>

          <ConsultationExportSummaryConcerns
            concerns={summary.potentialAreasOfConcern}
          />
        </View>
      )}

      <View style={[styles.section, styles.tight]} wrap={false}>
        <Text style={[styles.h2]}>Self-reported scores</Text>

        <ConsultationExportSummaryScores scores={summary.scores} />
      </View>
    </>
  );
};
